<div id="page-not-found" class="page-container">
  <div class="page-background">
    <span class="icon icon-error"></span>
    <span class="title">
      {{ message.title | translate: message.data }}
    </span>
    <div class="description">
      <ng-container *ngFor="let content of message.description" >
        <p class="content">{{ content | translate: message.data }}</p>
      </ng-container>
    </div>
    <lynx-button
      *ngIf="message.hasButton"
      (clickAction)="backToHome()"
      id="back-home"
      [text]="'Error.General.Button.BackToHome'"
    >
    </lynx-button>
  </div>
</div>
